import axios from 'axios'

export const fetchConfuguration = (campaignId, trackingId) => {
  return axios({
    method: 'GET',
    url: `testimonial/configuration/${campaignId}/${trackingId}`
  })
}

export const fetchReviews = (campaignId, trackingId) => {
  return axios({
    method: 'GET',
    url: `elasticsearch/testimonial/search/${trackingId}/${campaignId}`
  })
}
